<div class="modal fade" id="kt_modal_popular_vehicle_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Popular Vehicle' : 'Add Popular Vehicle' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="popularVehicleForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Make (Searchable) -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Make</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid"
                  [(ngModel)]="makeSearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onMakeSearchInput($event)"
                  (focus)="onMakeInputFocus()"
                  (blur)="onMakeInputBlur()"
                  placeholder="Search make..."
                  autocomplete="off"
                  [class.is-invalid]="make?.invalid && make?.touched" />

                <!-- Clear button -->
                <span *ngIf="selectedMake" class="position-absolute end-0 top-50 translate-middle-y me-3" style="cursor: pointer;" (click)="clearMake()">
                  <i class="ki-duotone ki-cross fs-4 text-gray-500">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>

                <!-- Make Search Dropdown -->
                <div *ngIf="showMakeDropdown" class="position-absolute w-100 bg-white border rounded shadow-sm mt-1" style="z-index: 1050; max-height: 200px; overflow-y: auto;">
                  <div *ngIf="isMakeSearching" class="p-3 text-center">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Searching...
                  </div>
                  <div *ngIf="!isMakeSearching && makeSearchResults.length === 0" class="p-3 text-center text-muted">
                    No results found
                  </div>
                  <div *ngFor="let makeItem of makeSearchResults"
                    class="p-2 cursor-pointer hover-bg-light"
                    style="cursor: pointer;"
                    (mousedown)="selectMake(makeItem)">
                    <span class="fw-semibold">{{ makeItem.name }}</span>
                  </div>
                </div>
              </div>

              <div *ngIf="make?.invalid && make?.touched" class="invalid-feedback d-block">
                <div *ngIf="make?.errors?.['required']">Make is required</div>
              </div>
            </div>

            <!-- Model (Searchable) -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Model</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid"
                  [(ngModel)]="modelSearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onModelSearchInput($event)"
                  (focus)="onModelInputFocus()"
                  (blur)="onModelInputBlur()"
                  placeholder="Search model..."
                  autocomplete="off"
                  [disabled]="!selectedMake"
                  [class.is-invalid]="model?.invalid && model?.touched" />

                <!-- Clear button -->
                <span *ngIf="selectedModel" class="position-absolute end-0 top-50 translate-middle-y me-3" style="cursor: pointer;" (click)="clearModel()">
                  <i class="ki-duotone ki-cross fs-4 text-gray-500">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>

                <!-- Model Search Dropdown -->
                <div *ngIf="showModelDropdown" class="position-absolute w-100 bg-white border rounded shadow-sm mt-1" style="z-index: 1050; max-height: 200px; overflow-y: auto;">
                  <div *ngIf="isModelSearching" class="p-3 text-center">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Searching...
                  </div>
                  <div *ngIf="!isModelSearching && modelSearchResults.length === 0" class="p-3 text-center text-muted">
                    No results found
                  </div>
                  <div *ngFor="let modelItem of modelSearchResults"
                    class="p-2 cursor-pointer hover-bg-light"
                    style="cursor: pointer;"
                    (mousedown)="selectModel(modelItem)">
                    <span class="fw-semibold">{{ modelItem.name }}</span>
                  </div>
                </div>
              </div>

              <div *ngIf="model?.invalid && model?.touched" class="invalid-feedback d-block">
                <div *ngIf="model?.errors?.['required']">Model is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
